import React from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Paper } from '@mui/material';
import { LoadingProvider } from '../util/LoadingContext';


export default function PanelCDNRoot(props) {

    return (
        <Paper style={{ minHeight: '100vh' }}>
            <LoadingProvider>
                <div >
                    <Outlet />
                </div>
            </LoadingProvider>
        </Paper>
    )

}